
export default {
  validate(value) {
    return new RegExp(/^[a-z0-9_]*$/g).test(value);
  },
  message: 'El campo {_field_} debe contener solo letras minúsculas, números y guiones bajos',
};
